import React from 'react';
import ToDoTickets from '../HR/CRM/ToDoTickets';

/**
 * TA To Do Tickets Page
 *
 * This component wraps the HR ToDoTickets component
 * and filters tickets to show only those assigned to the "Talent Acquisition" team.
 *
 * This ensures TA users only see tickets relevant to their department.
 */
function TAToDoTickets() {
  return <ToDoTickets teamFilter="TA" />;
}

export default TAToDoTickets;
